"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodeFromBase64 = void 0;
const win_1 = require("./win");
const decodeFromBase64 = (base64Str) => {
    if (typeof win_1.win !== 'undefined' && win_1.win.atob) {
        return win_1.win.atob(base64Str);
    }
    // worker env
    if (typeof self !== 'undefined' && self.WorkerGlobalScope) {
        return self.atob(base64Str);
    }
    // NodeJS env
    if (typeof Buffer !== 'undefined' && Buffer.from) {
        return Buffer.from(base64Str, 'base64').toString('utf-8');
    }
    throw new Error(`Failed to decode responseToken from base64. Either window.atob (browser/jsdom) or Buffer.from (NodeJS) should be available`);
};
exports.decodeFromBase64 = decodeFromBase64;
//# sourceMappingURL=decodeFromBase64.js.map